import { useProcess, useSelect } from '~/store'
import { selDocumentTypeOptions } from './st-folder-selectors'
import { Button, Dialog, DialogButtons, SearchableSelect } from '@st/theme'
import { STDocument } from '@st/sdk'
import { search } from '@st/util/search'
import { useState } from 'react'

function buildDocumentTypeSearchText(name: string): string {
  // Include collapsed form so "w2" matches "W-2"
  const collapsed = name.replace(/[^a-z0-9]+/gi, '')
  return name + ' ' + collapsed
}

export function STMoveDocumentDialog({
  folderId,
  doc,
  onClose
}: {
  folderId: string
  doc: STDocument
  onClose: () => void
}) {
  const stFolder = useProcess('stFolder')
  const documentTypes = useSelect('stFolder', selDocumentTypeOptions)
  const [destinationDocumentTypeId, setDestinationDocumentTypeId] = useState<string | undefined>(
    doc.documentTypeId
  )

  const handleMove = (documentTypeId: string) => {
    const documentType = documentTypes.find((option) => option.id == documentTypeId)
    if (!documentType) {
      return
    }

    stFolder.send({
      type: 'moveDocument',
      folderId,
      documentId: doc.id,
      documentName: doc.name,
      documentTypeId,
      destinationLabel: documentType.name
    })
    onClose?.()
  }

  return (
    <Dialog
      title="Move document"
      subtitle={`Where would you like to move ${doc.name}?`}
      buttons={
        <DialogButtons>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={
              destinationDocumentTypeId == undefined ||
              destinationDocumentTypeId == doc.documentTypeId
            }
            onClick={() => {
              if (!destinationDocumentTypeId) {
                return
              }

              handleMove(destinationDocumentTypeId)
            }}
          >
            Move
          </Button>
        </DialogButtons>
      }
    >
      <div className="flex flex-col gap-3">
        <SearchableSelect
          title="Categories"
          placeholder="Search categories"
          emptyLabel="No matching categories"
          ariaLabel="Select a destination category"
          className="w-full"
          value={destinationDocumentTypeId}
          options={documentTypes}
          buildValue={(documentType) => documentType.id}
          buildLabel={(documentType) => documentType.name}
          buildSearchText={(documentType) => buildDocumentTypeSearchText(documentType.name)}
          searchItems={(items, query) => search(items, (item) => item.searchText, query)}
          onChange={setDestinationDocumentTypeId}
        />
      </div>
    </Dialog>
  )
}
